import React from 'react';
import { Chip } from "@heroui/react";

interface StatusBadgeProps {
  status: boolean;
  availableText?: string;
  unavailableText?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
}

/**
 * StatusBadge - A reusable component for displaying status with color coding
 */
export default function StatusBadge({
  status,
  availableText = "Do wypożyczenia",
  unavailableText = "Wypożyczona",
  className = "",
  size = "sm"
}: StatusBadgeProps) {
  const statusLabel = status ? availableText : unavailableText;
  const statusColor = status ? "success" : "danger";
  
  return (
    <Chip
      className={`capitalize ${className}`}
      color={statusColor}
      size={size}
      variant="dot"
    >
      {statusLabel}
    </Chip>
  );
}